import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Sample team members with free online images
const teamMembers = [
    {
        name: "Sarah Anderson",
        designation: "Creative Director",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&h=600&fit=crop"
    },
    {
        name: "Michael Chen",
        designation: "Lead Developer",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=600&fit=crop"
    },
    {
        name: "Emily Rodriguez",
        designation: "Product Designer",
        image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=800&h=600&fit=crop"
    },
    {
        name: "James Wilson",
        designation: "Tech Lead",
        image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800&h=600&fit=crop"
    },
    {
        name: "Sophia Lee",
        designation: "Marketing Director",
        image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800&h=600&fit=crop"
    },
    {
        name: "David Kumar",
        designation: "Senior Engineer",
        image: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=800&h=600&fit=crop"
    },
];

const ImageTitleBars = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div className="w-full max-w-4xl mx-auto p-8">
            <div className="space-y-4">
                {teamMembers.map((member, index) => (
                    <motion.div
                        key={index}
                        className="relative h-32 rounded-xl overflow-hidden cursor-pointer group"
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                        whileHover={{ scale: 1.02 }}
                        transition={{ duration: 0.3 }}
                    >
                        {/* Background Image */}
                        <div
                            className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                            style={{ backgroundImage: `url(${member.image})` }}
                        />

                        {/* Dark Overlay */}
                        <div className="absolute inset-0 bg-black/60 group-hover:bg-black/40 transition-all duration-300" />

                        {/* Content Container */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <AnimatePresence mode="wait">
                                {hoveredIndex !== index ? (
                                    // Default State - Centered Text
                                    <motion.div
                                        key="default"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.2 }}
                                        className="text-center"
                                    >
                                        <h3 className="text-4xl font-bold text-white mb-2 tracking-tight">
                                            {member.name}
                                        </h3>
                                        <p className="text-lg text-gray-300 uppercase tracking-widest">
                                            {member.designation}
                                        </p>
                                    </motion.div>
                                ) : (
                                    // Hover State - Rotated Text
                                    <motion.div
                                        key="rotated"
                                        initial={{ opacity: 0, rotate: 0 }}
                                        animate={{ opacity: 1, rotate: -90 }}
                                        exit={{ opacity: 0, rotate: 0 }}
                                        transition={{ duration: 0.3 }}
                                        className="flex flex-col items-center"
                                        style={{
                                            writingMode: 'vertical-rl',
                                            textOrientation: 'mixed'
                                        }}
                                    >
                                        <h3 className="text-5xl font-black text-white mb-4 tracking-wider">
                                            {member.name}
                                        </h3>
                                        <p className="text-xl text-gray-200 uppercase tracking-[0.3em] font-medium">
                                            {member.designation}
                                        </p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>

                        {/* Gradient Border Effect on Hover */}
                        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-pink-500/20 rounded-xl" />
                        </div>

                        {/* Bottom Gradient */}
                        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-black/80 to-transparent" />
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default ImageTitleBars;
